import { GraphQLCall, validatedResponse } from "./helper";
import { 
    getPartnerPatientListQuery, 
    getPatientListWithVitalsDataQuery, 
    getPatientPopulationsDetailsQuery,
    getPatientDetailsWithCareTeamForPartnerQuery,
    getPatientDetailsForCareTeamQuery
} from "./graphQl/queries";
import { updatePatientDetails } from "./graphQl/mutations";

export const getGQLPatientList = async () => {
    try {
        const user = JSON.parse(sessionStorage.getItem("user"));

        const data = await GraphQLCall(
            getPartnerPatientListQuery,
            { limit: 100, offset: 0, partnerId: user?.orgId, }
        );

        const validatedData = validatedResponse("getPatientList", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const getGQLPatientDetails = async (variables) => {
    try {
        const user = JSON.parse(sessionStorage.getItem("user"));

        const data = await GraphQLCall(
            getPatientDetailsWithCareTeamForPartnerQuery,
            { ...variables, partnerId: user?.orgId, }
        );

        const validatedData = validatedResponse("getPatientDetailsWithCareTeamForPartner", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const getGQLPatientDetailsForCareTeam = async (variables) => {
    try {
        const data = await GraphQLCall(
            getPatientDetailsForCareTeamQuery,
            { ...variables }
        );

        const validatedData = validatedResponse("getPatientDetailsForCareTeam", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const saveNewUser = async (variables) => {
    try {
        const user = JSON.parse(sessionStorage.getItem("user"));

        const data = await GraphQLCall(updatePatientDetails, {
            partnerId: user?.orgId || variables["partnerId"],
            patientId: variables["patientId"],
            userCredId: variables["userCredId"],
            firstName: variables["patientFirstName"],
            lastName: variables["patientLastName"],
            phoneNo: variables["phoneNo"],
            birthDay: variables["birthDay"],
            address1: variables["address1"],
            gender: variables["gender"],
            careTeam: variables["careTeam"],
            emergencyContact: variables["emergencyContact"],
            insuranceDetails: typeof variables['insuranceDetails'] === 'string' ? JSON.parse(variables['insuranceDetails']) : variables['insuranceDetails'],
            knownDisease: typeof variables['knownDisease'] === 'string' ? JSON.parse(variables['knownDisease']) : variables['knownDisease']
        });

        const validatedData = validatedResponse("updatePatientDetails", data);
        return validatedData;
    } catch (error) {
        console.error("Error while saving new user:", error.message);
        throw error; // Ensure the error propagates to the caller
    }
};

export const saveExistingUser = async (variables) => {
    try {
        const user = JSON.parse(sessionStorage.getItem("user"));

        const data = await GraphQLCall(updatePatientDetails, {
            firstName: variables["patientFirstName"],
            lastName: variables["patientLastName"],
            email: variables["email"],
            partnerId: user?.orgId,
        });

        const validatedData = validatedResponse("updatePatientDetails", data);
        return validatedData;
    } catch (error) {
        console.error("Error while saving new user:", error.message);
        throw error; // Ensure the error propagates to the caller
    }
};

export const getPatientPopulationsDetails = async (variables) => {
    try {
        const data = await GraphQLCall(
            getPatientPopulationsDetailsQuery,
            variables
        );

        const validatedData = validatedResponse("getPatientsVitalsPopulations", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};

export const getPatientOptionsListWithVitalsData = async (variables) => {
    try {
        const data = await GraphQLCall(
            getPatientListWithVitalsDataQuery,
            {...variables, limit: 100, offset: 0}
        );

        const validatedData = validatedResponse("getPatientListWithVitalsData", data);
        return validatedData;
    } catch (error) {
        console.error("Error while fetching patient list:", error.message);
        throw error;
    }
};
